import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { IdleTimeoutManager } from '../../service/idle-timer-manager';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements OnInit, OnDestroy {
  notifier: NotifierService;
  constructor(private notifierService: NotifierService, public router: Router) {
    this.notifier = notifierService;
  }

  public timer;
  public showModal;
  public timeout;
  public warnTime = 30;
  public countdown = 30;
  public countInterval;
  ngOnInit(): void {
    this.showModal = false;
    this.timer = new IdleTimeoutManager({
      timeout: 15*60,
      onExpired: () => {
        // this.notifier.notify('warning', 'Expired');
        this.warn();
      }
    });
  }

  warn() {
    this.showModal = true;
    this.countdown = this.warnTime;
    this.countInterval = setInterval(() => {
      this.countdown--;
    }, 1000);
    this.timeout = setTimeout(() => {
      clearInterval(this.countInterval);
      this.showModal = false;
      this.notifier.notify('error', 'Logged Out');
      this.logout();
    }, this.warnTime * 1000)
  }

  logout() {
    localStorage.clear();
    document.getElementsByClassName("modal-backdrop fade show")?.[0]?.remove();
    this.router.navigateByUrl('/auth/login');
  }

  refresh() {
    this.showModal = false;
    clearTimeout(this.timeout);
    clearInterval(this.countInterval);
    this.timer._start();
  }

  ngOnDestroy() {
    this.timer.clear();
    clearTimeout(this.timeout);
    clearInterval(this.countInterval);
  }

}
